class Core {
    constructor() {
        this.currentTimeout = null;
    };
    wait(timeout) {
        if (this.currentTimeout) {
            clearTimeout(this.currentTimeout);
        };
        return new Promise(resolve => {
            this.currentTimeout = setTimeout(resolve, timeout);
        });
    };
};

window.addEventListener("load", function () {
    // scroll top 
    $(".btn-top").on("click", function () {
        $("html, body").animate({
            scrollTop: 0
        }, 0);
        return false;
    });
});